export const func = `#version 300 es
precision highp float;
#define PI 3.14159265359
uniform vec2 u_resolution;
uniform float u_time, u_siize;
out vec4 final;

float circleshape(vec2 position, float radius){
    return step(radius, length(position - vec2(0.5)));
}

float map(float value, float min1, float max1, float min2, float max2) {
   return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
   }


void main(){
   vec2 coord = gl_FragCoord.xy / u_resolution;
   vec3 color = vec3(0.24 + sin(u_time*0.000025), 0.58+ sin(u_time*0.0005), 0.97);
   vec3 color2 = vec3(0.5);
   vec3 color3 = vec3(0.44 + sin(u_time*0.00025), 0.58+ sin(u_time*0.0005), 0.97);

   float h = map(sin(u_time*0.0008),-1.0, 1.0, 0.25, 0.3);
   color = mix(color,vec3(1.0),sin(u_time*0.0005));
   
   color -= vec3(circleshape(coord+vec2(0.0-cos(u_time*0.0005)/5.0,0.0+ sin(u_time*0.0005)/5.0),0.3));



   final = vec4(color,1.0*sin(u_time*0.05));   
}
`;
